import { useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import {
  UniversalFilterTagIdValue,
  UniversalFilterTagIdModes,
  UniversalFilterTagIdFilterState,
  UniversalFilterTagIdOnChange
} from '../../UniversalFilterTagId.types';

interface UniversalFilterTagIdFilterStateOptions {
  onChange: UniversalFilterTagIdOnChange;
}

function useUniversalFilterTagIdFilterState({
  onChange
}: UniversalFilterTagIdFilterStateOptions) {
  // All modes and options available in handleApplyFilterState
  // must be implemented in handleParseFilterValue too
  const handleApplyFilterState = useCallback<
    (filterState: UniversalFilterTagIdFilterState) => void
  >(
    (filterState) => {
      const tagIds = filterState?.tagIds;

      if (filterState?.mode === UniversalFilterTagIdModes.CONTAINS_ANY_OF) {
        onChange(isEmpty(tagIds) ? undefined : { in: tagIds });
        return;
      }

      onChange();
    },
    [onChange]
  );

  const handleParseFilterValue = useCallback<
    (
      filterValue: UniversalFilterTagIdValue
    ) => UniversalFilterTagIdFilterState | undefined
  >((filterValue) => {
    if (isNil(filterValue)) {
      return undefined;
    }

    if (!isEmpty(filterValue.in)) {
      return {
        mode: UniversalFilterTagIdModes.CONTAINS_ANY_OF,
        tagIds: filterValue.in
      };
    }

    return undefined;
  }, []);

  return { handleApplyFilterState, handleParseFilterValue };
}

export default useUniversalFilterTagIdFilterState;
